import React from "react";

import { Placement } from "../../../util/enums";
import Checkbox from "../Checkbox";
import { TooltipPlacements } from "../ToolTipInfo";
import {
  Description,
  HeaderWrapper,
  RequiredLabel,
  StyledCheckboxWrapper,
  StyledFormControl,
  StyledFormHelperText,
  Title,
} from "./styles";

export type OptionProps = {
  value?: boolean;
  label?: string;
  ["data-cy"]?: string;
  onChange: () => void;
  hasError?: boolean;
  disabled?: boolean;
  tooltipText?: string;
  tooltipPlacement?: TooltipPlacements;
};

interface ICheckboxGroup {
  options: OptionProps[];
  label: string;
  error?: boolean;
  required?: boolean;
  errorMessage?: string;
  disabled?: boolean;
  description?: string;
  labelPlacement?: Placement;
  className?: string;
}

export const CheckboxGroup = ({
  options,
  label,
  error,
  required = false,
  errorMessage,
  description,
  labelPlacement = Placement.end,
  className,
}: ICheckboxGroup) => {
  const renderHeader = () => {
    if (label) {
      return (
        <HeaderWrapper>
          <Title>
            {label}
            {required && <RequiredLabel>*</RequiredLabel>}
          </Title>
          {description && <Description>{description}</Description>}
        </HeaderWrapper>
      );
    }

    return null;
  };

  const renderError = () => {
    if (error && errorMessage) {
      return <StyledFormHelperText>{errorMessage}</StyledFormHelperText>;
    }
  };

  return (
    <StyledFormControl>
      {renderHeader()}
      <StyledCheckboxWrapper className={className}>
        {options.map((option) => {
          return (
            <Checkbox
              key={option.label}
              label={option.label}
              error={option.hasError}
              disabled={option.disabled}
              onChange={option.onChange}
              labelPlacement={labelPlacement}
              checked={option.value}
              tooltipText={option.tooltipText}
              tooltipPlacement={option.tooltipPlacement}
            />
          );
        })}
      </StyledCheckboxWrapper>
      {renderError()}
    </StyledFormControl>
  );
};
